import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { DrProfile, DrProfilePref } from "src/app/shared/models/order.model";
import { AppState } from "src/app/shared/redux/store";

@Component({
  selector: "edit-profile-notes",
  templateUrl: "./edit-profile-notes.component.html",
  styleUrls: ["./edit-profile-notes.component.scss"],
  imports: [CommonModule, FormsModule, InputWrapComponent, TranslateModule],
  standalone: true,
})
export class EditProfileNotesComponent {
  @Input() profile: DrProfile;
  note: string;

  constructor() {}

  ngOnInit(): void {
    let pref = this.profile.pref.find(
      (p) => p.prefType == "NOTE" && p.noteLineType == "FORM"
    );
    this.note = pref?.note;
  }

  save() {
    let pref = this.profile.pref.find(
      (p) => p.prefType == "NOTE" && p.noteLineType == "FORM"
    );
    if (this.note) {
      if (pref) {
        pref.note = this.note;
      } else {
        let newPref = new DrProfilePref();
        newPref.prefType = "NOTE";
        newPref.noteLineType = "FORM";
        newPref.note = this.note;
        this.profile.pref.push(newPref);
      }
    } else if (pref) {
      this.profile.pref.splice(this.profile.pref.indexOf(pref), 1);
    }
  }
}
